export default __webpack_public_path__ + "static/IN-8015_16mm_lense_day-fbb95147bda9eb7d2112260afb344a70.webp";